/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllowedPlansQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AllowedPlansQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly allowedPlans: ReadonlyArray<GraphQL.AccountPlan> } | null };


export const AllowedPlansDocument = gql`
    query AllowedPlans($accountId: AccountId!) {
  account(id: $accountId) {
    id
    allowedPlans
  }
}
    `;

/**
 * __useAllowedPlansQuery__
 *
 * To run a query within a React component, call `useAllowedPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedPlansQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAllowedPlansQuery(baseOptions: Apollo.QueryHookOptions<AllowedPlansQuery, AllowedPlansQueryVariables> & ({ variables: AllowedPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllowedPlansQuery, AllowedPlansQueryVariables>(AllowedPlansDocument, options);
      }
export function useAllowedPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllowedPlansQuery, AllowedPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllowedPlansQuery, AllowedPlansQueryVariables>(AllowedPlansDocument, options);
        }
export function useAllowedPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllowedPlansQuery, AllowedPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllowedPlansQuery, AllowedPlansQueryVariables>(AllowedPlansDocument, options);
        }
export type AllowedPlansQueryHookResult = ReturnType<typeof useAllowedPlansQuery>;
export type AllowedPlansLazyQueryHookResult = ReturnType<typeof useAllowedPlansLazyQuery>;
export type AllowedPlansSuspenseQueryHookResult = ReturnType<typeof useAllowedPlansSuspenseQuery>;
export type AllowedPlansQueryResult = Apollo.QueryResult<AllowedPlansQuery, AllowedPlansQueryVariables>;